<template>
  <div>
    <v-card class="ma-3">
      <v-stepper v-model="stepper">
        <v-stepper-header>
          <v-stepper-step :complete="stepper > 1" step="1"
            >Settings</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step :complete="stepper > 2" step="2"
            >Recipients</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step step="3">Audio</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="4">Confirmation</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-layout row class="mx-0">
              <v-text-field
                class=""
                label="Broadcast Name"
                v-model="callName"
                ref="callName"
                style="max-width: 400px"
                :rules="[rules.required]"
              ></v-text-field>

              <!-- <v-checkbox
                                class="mt-3 ml-3"
                                v-model="confirmListing"
                                color="success"
                                label="Confirm Listing"
                                hide-details
                            ></v-checkbox> -->
            </v-layout>
            <v-layout column class="mx-0">
              <v-select
                class="pl-0 pr-3 mb-1"
                style="max-width: 400px"
                :items="terms"
                label="Term"
                ref="regID"
                :rules="[rules.required]"
                v-model="regID"
              ></v-select>
              <v-select
                class="pl-0 pr-3 mb-1"
                style="max-width: 400px"
                :items="branchList"
                label="Branch Filter"
                :rules="[rules.required]"
                ref="branch"
                v-model="branch"
                @change="branchChanged"
                clearable
                multiple
                :disabled="disableBranch()"
              ></v-select>
              <v-select
                v-if="branch"
                class="pr-3 mb-1"
                style="max-width: 400px"
                :items="gradeList"
                label="Grade Filter"
                multiple
                ref="grade"
                v-model="grade"
                @change="gradesChanged"
                clearable
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text caption"
                    >(+{{ grade.length - 1 }} others)</span
                  >
                </template>
              </v-select>
              <v-select
                class="pr-3 mb-1"
                style="max-width: 400px"
                :items="sectionList"
                label="Section Filter"
                multiple
                ref="section"
                v-model="section"
                @change="sectionChanged"
                clearable
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text caption"
                    >(+{{ section.length - 1 }} others)</span
                  >
                </template>
              </v-select>
            </v-layout>

            <v-card-actions class="pr-0 mr-0">
              <v-spacer></v-spacer>
              <v-btn color="default" dark @click="close()">
                Cancel
              </v-btn>
              <v-btn
                color="success"
                @click="continueToRecipients"
                :loading="loadingStudents"
              >
                Continue
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-layout row>
              <v-flex xs4>
                <v-layout row wrap>
                  <div class="font-weight-medium mr-2" v-if="branch.length">
                    Branch:
                  </div>
                  <div class="mr-3" v-if="branch.length">
                    {{ branch.join(",") }}
                  </div>
                  <div class="font-weight-medium mr-2" v-if="grade.length">
                    Grade:
                  </div>
                  <div class="mr-3" v-if="grade.length">
                    {{ grade.join(",") }}
                  </div>
                  <div class="font-weight-medium mr-2" v-if="section.length">
                    Section:
                  </div>
                  <div class="mr-3" v-if="section.length">
                    {{ section.join(",") }}
                  </div>
                </v-layout>
              </v-flex>
              <v-flex xs4>
                <v-layout row justify-center class="mb-3">
                  <v-btn
                    small
                    color="success"
                    outline
                    v-if="allowBroadcastToParents() && broadcastType == 'VOICE'"
                    @click="openChooseNumberDialog('studentList')"
                    >Add Students</v-btn
                  >
                  <v-btn
                    small
                    color="success"
                    outline
                    @click="openChooseNumberDialog('staffList')"
                    >Add Staff</v-btn
                  >
                  <v-btn
                    small
                    color="success"
                    outline
                    @click="openChooseNumberDialog('manualEntry')"
                    >Manually Add Numbers</v-btn
                  >
                </v-layout>
              </v-flex>
              <v-flex xs4> </v-flex>
            </v-layout>
            <v-layout row class="my-3">
              <div class="font-weight-medium mr-2 mt-2 title">
                Numbers ({{ numbers.length }})
              </div>
              <v-btn
                class="mb-2 mt-0"
                @click="clearNumbers"
                small
                color="success"
                ><v-icon dark left>mdi-close-circle</v-icon>Clear List</v-btn
              >
            </v-layout>
            <v-layout row>
              <div class="font-weight-regular" style="width: 35%">
                Number
              </div>
              <div class="font-weight-regular" style="width: 35%">
                Account ID
              </div>
              <div class="font-weight-regular" style="width: 35%">
                Name
              </div>
              <div class="font-weight-regular" style="width: 35%">
                Hebrew Name
              </div>
              <div class="font-weight-regular" style="width: 15%">
                Phone Type
              </div>
              <div style="min-width: 10%"></div>
              <!-- <v-btn
                                class="mt-0 pt-0"
                                style="width: 10%"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn> -->
            </v-layout>
            <v-divider class="mb-2"></v-divider>
            <div>
              <div v-for="(number, index) in numbersToDisplay">
                <v-layout row>
                  <!-- <v-checkbox
                                    class="mt-0 pt-0"
                                    style="max-width: 40px;"
                                    v-model="number.selected"
                                    color="success"
                                    hide-details
                                ></v-checkbox> -->
                  <div style="width: 35%">
                    {{ number.number | phone }}
                  </div>
                  <div style="width: 35%">
                    {{ number.accountID }}
                  </div>
                  <div style="width: 35%">
                    {{ number.name }}
                  </div>
                  <div style="width: 35%">
                    {{ number.nameH }}
                  </div>
                  <div style="width: 15%">
                    {{ number.phoneType }}
                  </div>
                  <v-btn
                    class="mt-0 pt-0"
                    style="width: 10%"
                    @click.stop="removeDisplayNumber(number)"
                    flat
                    icon
                    color="success"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-layout>
                <v-divider
                  class="mb-2"
                  v-if="index + 1 < numbers.length"
                ></v-divider>
              </div>
            </div>
            <v-layout justify-center class="mt-3 mb-1">
              <v-pagination
                v-model="pagination.page"
                :length="pages"
                :total-visible="5"
                v-on:input="setPagianation"
              ></v-pagination>
            </v-layout>
            <v-card-actions class="pr-0 mt-2 mr-0">
              <v-spacer></v-spacer>
              <v-btn outline @click="openConfirmCloseDialog">
                Back
              </v-btn>
              <v-btn color="success" @click="continueToAudio()">
                Continue
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-content step="3">
            <div v-if="broadcastType == 'VOICE'">
              <v-layout row class="mx-2 mb-2">
                <div
                  style="border: 2px solid rgb(76, 175, 80); border-radius: 5px;"
                  class="pa-2 font-weight-regular"
                >
                  Call Menahal Kesher line<span class="ml-1 font-weight-medium"
                    >929-605-0929 #9</span
                  >
                  to record your audio, once done press the
                  <span class="mr-1 font-weight-medium">Reload Library</span
                  >button
                </div>
              </v-layout>
              <v-layout row v-if="audioFile" class="ml-3 mt-3">
                <div class="font-weight-medium mr-3 pt-3">
                  Selected Recording:
                </div>
                <audio controls :src="audioFile"></audio>
              </v-layout>
              <v-layout class="mx-3 mt-3" row>
                <div
                  style=""
                  class="pt-3 text-xs-center font-weight-medium title"
                >
                  Click the recording you want to use
                </div>
                <v-spacer></v-spacer>
                <v-text-field
                  style="max-width: 250px;"
                  label="Search"
                  v-model="audioSearch"
                  hide-details
                  @input="onAudioSearch"
                  clearable
                  class="mx-2 mt-0 pb-1"
                ></v-text-field>
                <v-menu
                  v-model="audioDatePickerMenu"
                  :close-on-content-click="true"
                  offset-y
                  full-width
                  prepend-icon="mdi-calendar"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="audioFromDate"
                      :value="audioFromDate"
                      label="From Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      class="mx-2 mt-0 pb-1"
                      style="max-width: 200px"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="audioFromDate"
                    @change="audioFromDateChanged(audioFromDate)"
                  ></v-date-picker>
                </v-menu>
                <v-btn
                  :disabeld="loadingAudio"
                  small
                  color="success"
                  :loading="uploading"
                  @click="pickFile()"
                  ><v-icon dark left>mdi-cloud-upload</v-icon>Upload</v-btn
                >
                <input
                  type="file"
                  style="display: none"
                  ref="files"
                  accept=".mp3, .wav"
                  @change="onFilePicked($event)"
                />
                <v-btn
                  @click="loadAudioLibrary"
                  :disabeld="loadingAudio"
                  small
                  color="success"
                  ><v-icon dark left>mdi-reload</v-icon>Reload Library</v-btn
                >
              </v-layout>

              <div style="height: 500px; overflow-y: auto;" class="mx-3 mb-2">
                <div class="title" v-if="!audioLibrary.length">
                  No Recordings
                </div>

                <v-layout
                  row
                  class="pa-2 mb-2"
                  v-for="(audio, index) in audioLibrary"
                  @click="selectAudio(audio)"
                  style="cursor: pointer; border: 1px solid #4caf50; border-radius: 4px"
                >
                  <v-checkbox
                    v-model="audio.selected"
                    color="success"
                    class="ml-2 mt-2 pt-2 pr-3"
                    hide-details
                  ></v-checkbox>
                  <div style="width: 20%" class="pt-3 font-weight-regular">
                    {{ audio.date | time }}
                  </div>
                  <v-layout justify-center style="width: 30%">
                    <div v-if="!audio.editing" class="pt-3 font-weight-regular">
                      {{ audio.name }}
                    </div>
                    <v-btn
                      class="my-0 pt-2"
                      v-if="!audio.editing"
                      @click.stop="editAudio(audio)"
                      flat
                      icon
                      color="success"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-text-field
                      style="width: 30%"
                      class="pr-0 my-0 mr-3"
                      hide-details
                      v-if="audio.editing"
                      label="Name"
                      v-model="audio.name"
                    ></v-text-field>
                    <v-btn
                      class=""
                      v-if="audio.editing"
                      small
                      dark
                      @click.stop="cancelAudioName(audio)"
                      color="default"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      class="mr-3"
                      v-if="audio.editing"
                      small
                      @click.stop="saveAudioName(audio)"
                      color="success"
                    >
                      Save
                    </v-btn>
                  </v-layout>

                  <div style="width: 20%" class="pt-3">
                    <span class="font-weight-regular mr-1">From:</span>
                    <span v-if="audio.callerID != 'ADMIN PORTAL'">{{
                      audio.callerID | phone
                    }}</span>
                    <span v-else>{{ audio.callerID }}</span>
                  </div>
                  <div style="width: 10%" class="pt-3">
                    <span v-if="audio.branch" class="font-weight-regular mr-1"
                      >Branch:</span
                    >
                    <span v-if="audio.branch">{{ audio.branch }}</span>
                  </div>
                  <audio controls :src="audio.recordingURL"></audio>
                  <v-btn
                    class="my-0 pt-2"
                    @click.stop="openDeleteAudioDialog(audio)"
                    flat
                    icon
                    color="success"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-layout>
              </div>
              <div class="mx-3 mb-0 font-weight-medium">
                Files ({{ audioLibrary.length }})
              </div>
            </div>
            <div v-else>
              <div class="text-warning mb-2" v-if="showEnterNotice()">
                To move to the next line use the "shift + enter" keys
              </div>
              <v-textarea
                @keydown="onKeyDown"
                outline
                rows="8"
                label="Message"
                v-model="message"
                ref="message"
                :rules="[rules.required, rules.maxMessageLength]"
              ></v-textarea>
              <div>
                <span class="mx-1 font-weight-medium">Character count:</span>
                {{ getMessageCount(message) }}
              </div>
            </div>

            <v-card-actions class="pr-0 mr-0">
              <v-spacer></v-spacer>
              <v-btn outline @click="stepper = 2">
                Back
              </v-btn>
              <v-btn color="success" @click="continueToReview">
                Continue
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-content step="4">
            <div style="" class="pt-3 text-xs-center font-weight-medium title">
              Please Review
            </div>
            <v-layout row justify-space-between align-end>
              <div>
                <v-layout row class="px-3 py-2">
                  <div class="font-weight-medium mr-2 width-200">
                    Broadcast Name:
                  </div>
                  <div>
                    {{ callName }}
                  </div>
                </v-layout>
                <!-- <v-layout
                                    row
                                    class="px-3 py-2"
                                    v-if="isSchedule"
                                >
                                    <div
                                        class="font-weight-medium mr-2 width-200"
                                    >
                                        Broadcast Time:
                                    </div>
                                    <div>
                                        {{ getBroadcastTime() | time }}
                                    </div>
                                </v-layout> -->
                <v-layout row class="px-3 py-2">
                  <div class="font-weight-medium mr-2 width-200">
                    Caller ID:
                  </div>
                  <div>
                    {{ fromNumber | phone }}
                  </div>
                </v-layout>
                <div>
                  <v-layout row class="px-3 py-2">
                    <div class="font-weight-medium mr-2 width-200">
                      Total Calls
                    </div>
                    <div>
                      {{ getTotalCalls() }}
                    </div>
                  </v-layout>
                </div>
                <v-layout row class="px-3 py-2" v-if="broadcastType == 'VOICE'">
                  <div class="font-weight-medium mr-2 width-200">
                    Audio:
                  </div>
                  <audio
                    controls
                    :src="audioFile"
                    style="width: 323px;"
                  ></audio>
                </v-layout>
                <v-layout
                  row
                  class="px-3 py-2"
                  v-if="message && broadcastType == 'TEXT'"
                >
                  <div class="font-weight-medium mr-2 width-200">
                    Message:
                  </div>
                  <div style="width: 60%">
                    {{ message }}
                  </div>
                </v-layout>
                <v-layout row class="px-3 time-list">
                  <v-switch
                    color="success"
                    class="mt-2 mr-3 width-180"
                    v-model="isSchedule"
                    label="Schedule For Later"
                  ></v-switch>
                  <v-menu
                    v-model="datePickerMenu"
                    v-if="isSchedule"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="broadcastDate"
                        label="Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="width-150 mr-2 mt-0"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="broadcastDate"
                      :min="today"
                    ></v-date-picker>
                  </v-menu>
                  <DxDateBox
                    style="height: 45px; max-width: 150px"
                    type="time"
                    v-if="isSchedule"
                    picker-type="list"
                    :interval="15"
                    ref="broadcastTime"
                    v-model="broadcastTime"
                  />
                </v-layout>
              </div>
              <v-layout class="mb-0" row justify-end>
                <v-text-field
                  v-model="testNumber"
                  class="mx-2"
                  style="max-width: 150px; min-width: 150px;"
                  label="Test Number"
                  ref="testNumber"
                  :rules="[rules.phoneNumber]"
                ></v-text-field>
                <v-btn
                  :disabled="!testNumber"
                  color="success"
                  class="mt-3 mb-0"
                  style="height: 28px;"
                  small
                  @click="send(true)"
                  >Send Test Call
                </v-btn>
              </v-layout>
            </v-layout>
            <v-card-actions class="pr-0 mt-2 mr-0">
              <v-spacer></v-spacer>
              <v-btn outline @click="stepper = 3">
                Back
              </v-btn>
              <v-btn :loading="sending" color="success" @click="send()">
                Send
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>

    <v-dialog v-model="confirmCloseDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0">
          Are you sure?
        </v-card-title>
        <div class="mb-3">This will clear the list of numbers</div>
        <v-card-actions class="mr-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="confirmCloseDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="success" @click="goBackToSettings()">Go Back</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="chooseNumbersDialog" max-width="1300">
      <v-card class="pa-3">
        <v-flex
          xs12
          class="px-0 pb-0 xs4 pt-0 scroll"
          style="height: 570px; overflow-y: auto;"
          ><div v-if="selectNumberMode == 'studentList'">
            <v-tabs v-model="studentListTab" hide-slider>
              <v-tabs-slider color="success"></v-tabs-slider>
              <v-tab
                href="#parents"
                v-bind:class="{
                  'selected-tab': studentListTab == 'parents',
                }"
                >PARENTS ({{ parentCount }})</v-tab
              >
              <v-tab
                href="#students"
                v-bind:class="{
                  'selected-tab': studentListTab == 'students',
                }"
                >STUDENTS ({{ students.length }})</v-tab
              >
            </v-tabs>
            <v-tabs-items v-model="studentListTab">
              <v-tab-item value="parents">
                <v-data-table
                  v-model="selectedParents"
                  :headers="parentHeaders"
                  :items="parents"
                  :pagination.sync="parentPagination"
                  select-all
                  item-key="familyID"
                  class="elevation-0"
                  :rows-per-page-items="[9, 15, 20]"
                >
                  <template v-slot:headers="props">
                    <tr>
                      <th>
                        <v-checkbox
                          :input-value="props.all"
                          :indeterminate="props.indeterminate"
                          primary
                          hide-details
                          @click.stop="toggleAllParents"
                          color="success"
                        ></v-checkbox>
                      </th>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                        class="text-xs-left"
                      >
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template v-slot:items="props">
                    <tr
                      :active="props.selected"
                      @click="props.selected = !props.selected"
                    >
                      <td>
                        <v-checkbox
                          :input-value="props.selected"
                          color="success"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td>{{ props.item.familyID }}</td>
                      <td>
                        {{ props.item.name }}
                      </td>
                      <td>
                        {{ props.item.hname }}
                      </td>
                      <td>{{ props.item.address1 }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item value="students">
                <v-data-table
                  :headers="studentHeaders"
                  :items="students"
                  :pagination.sync="studentPagination"
                  select-all
                  item-key="studentID"
                  class="elevation-0"
                  :rows-per-page-items="[9, 15, 20]"
                >
                  <template v-slot:headers="props">
                    <tr>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                        class="text-xs-left"
                      >
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template v-slot:items="props">
                    <tr>
                      <td>{{ props.item.studentID }}</td>
                      <td>
                        {{ props.item.studentName }}
                      </td>
                      <td>
                        {{ props.item.studentNameH }}
                      </td>
                      <td>{{ props.item.section }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </div>
          <div v-if="selectNumberMode == 'staffList'">
            <v-layout row justify-space-between class="mb-0">
              <v-btn
                small
                color="success"
                @click="toggleAllStaff"
                style="height: 28px;"
                >{{
                  selectedStaff.length ? "Unselect All" : "Select All"
                }}</v-btn
              >
              <v-spacer></v-spacer>
              <v-text-field
                style="max-width: 250px;"
                v-model="searchStaff"
                append-icon="mdi-search"
                label="Search"
                class="mr-2 mb-2"
                clearable
                hide-details
                @input="searchStaffChanged"
              ></v-text-field>
              <!-- <v-select
                v-model="selectedTeacherTypes"
                label="Teacher Type"
                clearable
                multiple
                :items="teacherTypes"
                hide-details
                @input="onTeacherTypeChanged"
                class="mr-2"
                style="max-width: 250px"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text caption"
                    >(+{{ selectedTeacherTypes.length - 1 }} others)</span
                  >
                </template>
              </v-select> -->
            </v-layout>
            <v-data-table
              v-model="selectedStaff"
              :headers="staffHeaders"
              :items="filteredStaff"
              :pagination.sync="staffPagination"
              item-key="employeeID"
              class="elevation-0"
              :rows-per-page-items="[8, 15, 20, 50, 100]"
            >
              <template v-slot:headers="props">
                <tr>
                  <th class="pb-1">
                    <!-- <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      hide-details
                      @click.stop="toggleAllStaff"
                      color="success"
                    ></v-checkbox> -->
                  </th>
                  <th
                    v-for="header in props.headers.filter((h) => h.text)"
                    :key="header.value || header.text"
                    class="text-xs-left pb-0"
                    :class="{ sortable: header.sortable !== false }"
                    @click="
                      header.sortable !== false && changeSort(header.value)
                    "
                    :aria-sort="
                      staffPagination.sortBy === header.value
                        ? staffPagination.descending
                          ? 'descending'
                          : 'ascending'
                        : 'none'
                    "
                    style="cursor: pointer;"
                  >
                    <span>{{ header.text }}</span>
                    <v-icon
                      small
                      v-if="staffPagination.sortBy === header.value"
                    >
                      {{
                        staffPagination.descending
                          ? "mdi-arrow-down"
                          : "mdi-arrow-up"
                      }}
                    </v-icon>
                  </th>
                </tr>
                <tr class="staff-filter-row">
                  <th
                    v-for="header in props.headers"
                    :key="header.value + '-filter'"
                    class="text-xs-left pt-0"
                  >
                    <v-select
                      v-if="header.value && header.value !== 'selected'"
                      v-model="staffFilterSelections[header.value]"
                      :items="staffFilterOptions[header.value] || []"
                      multiple
                      hide-details
                      dense
                      small-chips
                      clearable
                      @click.stop
                      placeholder="Filter"
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0" small>
                          <span>{{ item }}</span>
                        </v-chip>
                        <span
                          v-if="index === 1"
                          class="grey--text caption"
                          style="margin-bottom:0;padding-bottom:0;"
                          >(+{{
                            staffFilterSelections[header.value].length - 1
                          }}
                          others)</span
                        >
                      </template>
                    </v-select>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr
                  :active="props.selected"
                  @click="props.selected = !props.selected"
                >
                  <td>
                    <v-checkbox
                      :input-value="props.selected"
                      color="success"
                      primary
                      hide-details
                    ></v-checkbox>
                  </td>
                  <td>{{ props.item.employeeID }}</td>
                  <td class="width-250">
                    {{ props.item.teacherH }}
                  </td>
                  <td>
                    {{ props.item.class }}
                  </td>
                  <td>{{ props.item.section }}</td>
                  <td>{{ props.item.branch }}</td>
                  <td>{{ props.item.alertPhone }}</td>
                  <td>{{ props.item.type }}</td>
                  <td>{{ props.item.note }}</td>
                  <td>{{ props.item.createdBy }}</td>
                  <td>
                    {{ props.item.busNumber ? props.item.busNumber : "" }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <div
            v-if="selectNumberMode == 'manualEntry'"
            class="mt-3"
            style="height: 500px; overflow-y: auto;"
          >
            <v-layout row v-for="(number, index) in manualNumbers">
              <v-text-field
                class="px-1 mr-2"
                label="Number"
                v-model="number.number"
                ref="manualNumber"
                style="max-width: 50%;"
              ></v-text-field>
              <v-btn @click="addNumber" flat icon color="success">
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
              <v-btn
                :disabled="index == 0"
                @click="removeNumber(index)"
                flat
                icon
                color="#f55a4e"
              >
                <v-icon>mdi-minus-circle-outline</v-icon>
              </v-btn>
            </v-layout>
          </div>
        </v-flex>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-select
            v-if="selectNumberMode == 'studentList'"
            class="pl-0 mr-3 pt-1 mb-0"
            style="max-width: 200px"
            :items="getPhoneTypeList()"
            label="Phone Type"
            :rules="[rules.required]"
            ref="broadcastCallPhoneTypes"
            v-model="phoneTypes"
          ></v-select>
          <!-- <v-spacer></v-spacer> -->
          <v-btn dark color="default" @click="chooseNumbersDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="success" :loading="addingNumbers" @click="addNumbers"
            >Add Numbers</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="deleteAudioDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="text-warning headline">Are You Sure?</v-card-title>
        <v-card-text class="mb-3 py-0">
          You will now delete {{ audioToDelete.name }} audio file
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="deleteAudioDialog = false"
            >Close</v-btn
          >
          <v-btn :loading="deleting" color="success" @click="deleteAudio()"
            >Delete</v-btn
          >
        </v-card-actions>
        <div class="font-weight-light text-xs-center" style="color: #00d3ee">
          {{ processingMessages }}
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import {
  getDomain,
  formatPhoneNumber,
  onlyUnique,
  groupBy,
  toTitleCase,
  toISOLocal,
  firstToLower,
  except,
} from "../../utils/helpers.js";
import DxDateBox from "devextreme-vue/date-box";

export default {
  components: {
    DxDateBox,
  },
  data: () => ({
    processing: false,
    stepper: 0,
    numbersToDisplay: [],
    numbers: [],
    callName: "",
    confirmListing: false,
    fromNumber: "19299550923",
    selectNumberMode: "",
    confirmCloseDialog: false,
    chooseNumbersDialog: false,
    addingNumbers: false,

    branchList: [],
    branch: [],
    staffBranch: [],

    gradeList: [],
    staffGradeList: [],
    grade: [],
    staffGrade: [],

    sectionList: [],
    section: [],
    teachers: [],

    manualNumbers: [],

    terms: [],

    loadingAudio: false,
    audioLibrary: [],
    allAudioLibrary: [],
    audioSearch: "",
    audioFromDate: "",
    audioDatePickerMenu: false,
    audioToDelete: "",
    deleteAudioDialog: false,
    deleting: false,
    selectedAudio: "",
    audioFile: "",
    message: "",
    uploading: false,
    files: [],
    processingMessages: "",
    showParentsTable: false,

    studentListTab: "parents",
    studentCount: 0,
    parentCount: 0,
    numbersCount: "",
    source: "tuition",
    sending: false,
    regID: "",

    isSchedule: false,
    datePickerMenu: false,
    broadcastTime: new Date(),
    broadcastDate: toISOLocal(new Date(moment())).substr(0, 10),
    today: toISOLocal(new Date(moment())).substr(0, 10),

    phoneTypes: "",
    testNumber: "",
    broadcastType: "VOICE",

    selectedParents: [],
    students: [],
    studentPagination: {
      sortBy: "studentName",
      rowsPerPage: 9,
    },
    parents: [],
    parentPagination: {
      sortBy: "name",
      rowsPerPage: 9,
    },
    staff: [],
    allStaff: [],
    selectedStaff: [],
    selectedTeacherTypes: [],
    teacherTypes: [],
    staffPagination: {
      sortBy: "name",
      rowsPerPage: 8,
    },

    loadingStudents: false,
    loadingStaff: false,

    phoneType: {
      homePhone: false,
      cellPhone: false,
      motherPhone: false,
    },

    pagination: {
      totalCount: 0,
      rowsPerPage: 13,
      page: 1,
    },

    rules: {
      required: (value) => !!value || "Required.",
      maxMessageLength: (value) => {
        let count = 0;
        for (let i = 0; i < value.length; i++) {
          let code = value.charCodeAt(i);
          if (code < 128) {
            count++;
          } else if (code < 2048) {
            count += 2;
          } else if (code < 65536) {
            count += 3;
          } else {
            count += 4;
          }
        }

        return !value || count < 738 || "Max length is 737";
      },
      phoneNumber: (v) => {
        return (
          !v ||
          ([10, 11].includes(v.replace(/-/g, "").length) &&
            /^\d+$/.test(v.replace(/-/g, ""))) ||
          "Invalid Phone Number"
        );
      },
    },

    studentUrl: "",
    searchStaff: "",

    studentHeaders: [
      {
        text: "Student ID",
        value: "studentID",
        align: "left",
      },
      { text: "Name", value: "studentName", align: "left" },
      { text: "Hebrew Name", value: "studentNameH", align: "left" },
      { text: "Section", value: "sectionDescription", align: "left" },
    ],

    parentHeaders: [
      {
        text: "Family ID",
        value: "familyID",
      },
      { text: "Name", value: "name" },
      { text: "Hebrew Name", value: "hname" },
      { text: "Address", value: "address1" },
    ],

    staffHeaders: [
      {
        text: "",
        value: "selected",
      },
      { text: "Employee ID", value: "employeeID", sortable: true },
      { text: "Teacher", value: "teacherH", sortable: true, width: "250px" },
      { text: "Class", value: "class", sortable: true },
      { text: "Section", value: "section", sortable: true },
      { text: "Branch", value: "branch", sortable: true },
      { text: "Phone", value: "alertPhone" },
      { text: "Type", value: "type" },
      { text: "Note", value: "note" },
      { text: "Created By", value: "createdBy" },
    ],

    studentColumns: [
      {
        sortable: false,
        label: "Student ID",
        field: "studentID",
        hidden: false,
      },
      {
        sortable: true,
        label: "Name",
        field: "studentName",
        hidden: false,
      },
      {
        sortable: false,
        label: "Hebrew Name",
        field: "studentNameH",
        hidden: false,
      },
      {
        sortable: false,
        label: "Section",
        field: "sectionDescription",
        hidden: false,
      },
    ],

    parentColumns: [
      {
        sortable: false,
        label: "Family ID",
        field: "familyID",
        link: "Account View",
        hidden: false,
      },
      {
        sortable: true,
        label: "Name",
        field: "name",
        hidden: false,
      },
      {
        sortable: false,
        label: "Hebrew Name",
        field: "hname",
        hidden: false,
      },
      {
        sortable: false,
        label: "Address",
        field: "address1",
        hidden: false,
      },
    ],

    staffUrl: "",

    staffColumns: [
      {
        sortable: false,
        label: "Employee ID",
        field: "employeeID",
        hidden: false,
      },
      {
        sortable: true,
        label: "Teacher",
        field: "teacherH",
        hidden: false,
      },
      {
        sortable: true,
        label: "Class",
        field: "class",
        hidden: false,
      },
      {
        sortable: true,
        label: "Section",
        field: "section",
        hidden: false,
      },
      {
        sortable: false,
        label: "Branch",
        field: "branch",
        hidden: false,
      },
      {
        sortable: false,
        label: "Phone",
        field: "alertPhone",
        hidden: false,
      },
      {
        sortable: false,
        label: "Type",
        field: "type",
        hidden: false,
      },
    ],
    staffFilterSelections: {
      employeeID: [],
      teacherH: [],
      class: [],
      section: [],
      branch: [],
      alertPhone: [],
      type: [],
      note: [],
      createdBy: [],
      busNumber: [],
    },
  }),
  computed: {
    pages() {
      return this.pagination.rowsPerPage
        ? Math.ceil(this.numbers.length / this.pagination.rowsPerPage)
        : 0;
    },
    staffFilterOptions() {
      const opts = {
        employeeID: [],
        teacherH: [],
        class: [],
        section: [],
        branch: [],
        alertPhone: [],
        type: [],
        note: [],
        createdBy: [],
        busNumber: [],
      };
      // Collect unique values, adding a blank option ("") when any row has an empty value
      const push = (arr, v) => {
        if (v === undefined || v === null || v === "") {
          if (!arr.includes("")) arr.push("");
          return;
        }
        if (!arr.includes(v)) arr.push(v);
      };
      (this.staff || []).forEach((s) => {
        push(opts.employeeID, s.employeeID);
        push(opts.teacherH, s.teacherH);
        push(opts.class, s.class);
        push(opts.section, s.section);
        push(opts.branch, s.branch);
        push(opts.alertPhone, s.alertPhone);
        push(opts.type, s.type);
        push(opts.note, s.note);
        push(opts.createdBy, s.createdBy);
        if (s.busNumber) push(opts.busNumber, s.busNumber);
      });
      // Sort while keeping blank ("") at the top if present
      Object.keys(opts).forEach((k) => {
        opts[k].sort();
        if (opts[k].includes("")) {
          opts[k] = [""].concat(opts[k].filter((v) => v !== ""));
        }
      });
      return opts;
    },
    filteredStaff() {
      const sels = this.staffFilterSelections || {};
      const any = Object.keys(sels).some((k) => (sels[k] || []).length);
      if (!any) return this.staff;
      return this.staff.filter((row) => {
        return Object.keys(sels).every((k) => {
          const sel = sels[k];
          if (!sel || !sel.length) return true;
          return sel.includes(row[k]);
        });
      });
    },
  },
  watch: {
    // Auto-select all rows when the staff grid is filtered/updated
    filteredStaff(newRows) {
      const rows = Array.isArray(newRows) ? newRows : [];
      const set = new Set(rows);
      (this.staff || []).forEach((r) => {
        r.selected = set.has(r);
      });
      this.selectedStaff = rows.slice();
    },
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("keyup", (e) => this.onKeyPressed(e));
  },
  beforeDestroy() {},
  async created() {
    window.addEventListener("keyup", (e) => this.onKeyPressed(e));

    if (this.$route.query.broadcastText) {
      this.broadcastType = "TEXT";
    }

    this.setBroadcastTime();

    await this.loadTerms();
    await this.loadRegID();
    await this.loadBranchList(true);
    await this.loadGradesList();
    await this.loadTeacherList();

    this.loadAudioLibrary();
    this.addNumber();
  },
  methods: {
    onKeyPressed(e) {
      if (e.keyCode == 13) {
        console.log("enter");
        e.preventDefault();
      }
    },
    close() {
      this.$router.push({
        name: "MenahalBroadcasts",
      });
    },
    async loadTerms() {
      this.terms = await this.$http.get("api/allStudents/getRegTerms");
    },
    async loadRegID() {
      this.regID = await this.$http.get("api/allStudents/getRegID");
    },
    async continueToRecipients() {
      const validations = [
        this.$refs.callName.validate(true),
        this.$refs.regID.validate(true),
      ];

      if (!validations.every(Boolean)) return;

      if (this.$store.state.authentication.branch && !this.branch.length) {
        return this.$notify({
          text: "Please choose branch",
          group: "notification",
          type: "error",
        });
      }

      await this.loadStudents();
      await this.loadStaff();
      await this.loadContacts();

      this.stepper = 2;

      //this.loadStudentsGrid();
    },
    async loadStudents() {
      this.loadingStudents = true;

      const grades = [this.grade.join(","), this.getGradeQueryFromSection()];

      const url =
        "odata/allStudents?branch=" +
        (this.branch ? this.branch.map(this.getBranchCode).join(",") : "") +
        "&grade=" +
        grades.join(",") +
        "&section=" +
        this.getSectionQuery() +
        "&regID=" +
        this.regID;

      try {
        const response = await this.$http.get(url);

        this.students = response.value;

        const group = groupBy(this.students, "familyID");

        this.parentCount = Object.keys(group).length;
        this.parents = Object.keys(group)
          .map((accountID) => {
            return group[accountID][0];
          })
          .map((parent) => {
            parent.selected = true;

            return parent;
          });
        this.selectedParents = this.parents;

        this.loadingStudents = false;
      } catch (e) {
        this.loadingStudents = false;
      }
    },
    async loadStaff() {
      this.loadingStaff = true;

      const url =
        "odata/kesherEmployees?branch=" +
        (this.branch ? this.branch.map(this.getBranchCode).join(",") : "") +
        "&grade=" +
        this.grade.join(",") +
        "&section=" +
        this.getSectionQuery() +
        "&regID=" +
        this.regID;

      try {
        const response = await this.$http.get(url);

        if (
          response.value.some((s) => s.busNumber) &&
          !this.staffHeaders.some((s) => s.value == "busNumber")
        ) {
          this.staffHeaders.push({
            text: "Bus #",
            value: "busNumber",
            sortable: true,
          });
        }

        this.staff = response.value
          .map((teacher) => {
            teacher.teacherH = teacher.teacherH
              ? teacher.teacherH
              : teacher.teacher;
            teacher.selected = true;
            teacher.createdBy = "";

            return teacher;
          })
          .filter((teacher) => {
            const branchList = this.branch.map(this.getBranchCode);

            return branchList.includes(teacher.branch);
          });

        if (this.branch.length == 1 && this.branch.includes("BUS - באס")) {
          this.staff = this.staff.filter((s) => s.positionCode == "BUS_DRIVER");
        }

        this.allStaff = this.staff;

        this.teacherTypes = this.staff.map((s) => s.type).filter(onlyUnique);
        this.selectedTeacherTypes = this.teacherTypes;

        this.selectedStaff = this.staff;

        this.loadingStaff = false;
      } catch (e) {
        this.loadingStaff = false;
      }
    },
    async loadContacts() {
      this.loadingStaff = true;

      const url =
        "odata/broadcastContact?branch=" +
        (this.branch ? this.branch.map(this.getBranchCode).join(",") : "");

      try {
        const response = await this.$http.get(url);

        const contacts = response.value
          .map((contact) => {
            contact.teacherH = contact.nameH ? contact.nameH : contact.name;

            contact.type = "CONTACT";
            contact.alertPhone = contact.phoneNumber;
            contact.employeeID = "CONTACT" + contact.id;
            contact.class = "";
            contact.section = "";

            contact.selected = true;

            return contact;
          })
          .filter((contact) => {
            const branchList = this.branch.map(this.getBranchCode);

            return branchList.includes(contact.branch);
          });

        contacts.forEach((contact) => {
          this.staff.push(contact);
        });

        this.allStaff = this.staff;
        this.teacherTypes.push("CONTACT");
        this.selectedTeacherTypes.push("CONTACT");

        this.selectedStaff = this.staff;

        this.loadingStaff = false;
      } catch (e) {
        this.loadingStaff = false;
      }
    },
    onTeacherTypeChanged(value) {
      this.staff = this.allStaff.filter((s) => value.includes(s.type));
    },
    searchStaffChanged(value) {
      if (!value) {
        this.staff = this.allStaff;

        return;
      }

      value = value.toLowerCase();

      this.staff = this.allStaff.filter(
        (s) =>
          s.employeeID.toString().includes(+value) ||
          s.teacherH.toLowerCase().includes(value) ||
          s.branch.toLowerCase().includes(value) ||
          s.alertPhone.toLowerCase().includes(value) ||
          s.createdBy.toLowerCase().includes(value) ||
          (s.notes && s.notes.toLowerCase().includes(value)) ||
          (s.note && s.note.toLowerCase().includes(value))
      );
    },
    toggleAllParents() {
      if (this.selectedParents.length) this.selectedParents = [];
      else this.selectedParents = this.parents.slice();
    },
    toggleAllStaff() {
      // Toggle selection only for currently filtered rows (visible rows)
      const current = this.filteredStaff;
      const allSelected =
        current.length &&
        current.every((row) => this.selectedStaff.includes(row));
      if (allSelected) {
        // Deselect only those currently visible
        this.selectedStaff = this.selectedStaff.filter(
          (s) => !current.includes(s)
        );
      } else {
        // Add any missing filtered rows
        const set = new Set(this.selectedStaff);
        current.forEach((r) => set.add(r));
        this.selectedStaff = Array.from(set);
      }
    },
    changeSort(column) {
      if (this.staffPagination.sortBy === column) {
        this.staffPagination.descending = !this.staffPagination.descending;
      } else {
        this.staffPagination.sortBy = column;
        this.staffPagination.descending = false;
      }
    },
    disableChooseNumberAction(action) {
      return false;
    },
    setBroadcastTime() {
      const broadcastTime = moment().toDate();
      const currentTime = broadcastTime.getTime();
      const updatedTime = new Date(currentTime + 2 * 60 * 60 * 1000);

      updatedTime.setMinutes(0);

      this.broadcastTime = updatedTime;
    },
    async loadBranchList(shouldSetBranch = false) {
      let grade = this.grade
        ? this.grade.filter((b) => this.gradeList.includes(b))
        : "";

      grade = grade ? grade.join(",") : "";

      const branches = await this.$http.get(
        "api/students/getBranchListDetails?grades=" + grade
      );

      this.branchList = branches
        .filter((b) => b.branchCode)
        .sort((a, b) => {
          if (a.branchCode < b.branchCode) {
            return -1;
          }
          if (a.branchCode > b.branchCode) {
            return 1;
          }
          return 0;
        })
        .map((b) => b.branchCode + " - " + b.branchDescH);

      this.branchList.push("BUS - באס");

      const allBranches = this.branchList;

      if (
        this.$store.state.authentication.branch &&
        !this.$store.state.authentication.branch.includes("null")
      ) {
        let list = this.$store.state.authentication.branch
          .split(",")
          .map((b) => {
            const branch = allBranches.find(
              (br) => this.getBranchCode(br) == b
            );

            return branch;
          });

        this.branchList = list;

        if (this.isTransportationRole()) {
          list = ["BUS - באס"];
        }

        if (shouldSetBranch) {
          this.branch = list;
          this.staffBranch = list;
        }
      }
    },
    getBranchCode(branch) {
      return branch.split(" - ")[0];
    },
    branchChanged(value) {
      const branch = value;

      localStorage.setItem("broadcast-call-branch", branch);

      this.loadGradesList();
      this.loadTeacherList();
    },
    disableBranch() {
      return false;

      if (!this.$store.state.authentication.branch) return false;

      return (
        this.$store.state.authentication.branch &&
        !this.$store.state.authentication.branch.includes("null")
      );
    },
    hasUserBranch() {
      return (
        this.$store.state.authentication.branch &&
        !this.$store.state.authentication.branch.includes("null")
      );
    },
    getMessageCount(value) {
      if (!value) return 0;

      let count = 0;
      for (let i = 0; i < value.length; i++) {
        let code = value.charCodeAt(i);
        if (code < 128) {
          count++;
        } else if (code < 2048) {
          count += 2;
        } else if (code < 65536) {
          count += 3;
        } else {
          count += 4;
        }
      }

      return count;
    },
    async loadGradesList() {
      let branch = this.branch.length ? this.branch : "";

      branch = branch ? branch.map(this.getBranchCode).join(",") : "";

      if (!branch && this.hasUserBranch()) {
        branch = this.branchList.map(this.getBranchCode).join(",");
      }

      const grades = await this.$http.get(
        "api/students/getGradeList?branch=" +
          branch +
          "&section=" +
          this.getSectionQuery()
      );

      this.gradeList = grades.sort();
      this.gradeList.unshift("Select All");

      const allGrades = await this.$http.get(
        "api/students/getGradeList?branch=" + branch
      );

      this.staffGradeList = allGrades.sort();
      this.staffGradeList.unshift("Select All");
    },
    async loadTeacherList() {
      let branch = this.branch.length
        ? this.branch.map(this.getBranchCode).join(",")
        : "";

      if (!branch && this.hasUserBranch()) {
        branch = this.branchList.map(this.getBranchCode).join(",");
      }

      let grade = this.grade
        ? this.grade.filter((b) => this.gradeList.includes(b))
        : "";

      grade = grade ? grade.join(",") : "";

      const teachers = await this.$http.get(
        "api/students/GetSectionList?regID=" +
          this.regID +
          "&branches=" +
          branch +
          "&grades=" +
          grade
      );

      this.sectionList = teachers;

      //this.teachers = teachers.filter((t) => t.regID == this.regID);

      // this.sectionList = this.teachers
      //     .map(
      //         (s) =>
      //             "(" + s.class + ") | " + s.section + " - " + s.teacherH,
      //     )
      //     .filter(onlyUnique)
      //     .sort();

      this.sectionList = this.sectionList.filter(onlyUnique).sort();
      this.sectionList.unshift("Select All");

      // this.section = this.section.filter((s) => {
      //     const grade = s.split(" | ")[0].replace(/\(|\)/g, "");
      //     const section = s.split(" | ")[1].split(" - ")[0];
      //     const teacherName = s.split(" | ")[1].split(" - ")[1];

      //     const teacher = this.teachers.find(
      //         (t) =>
      //             t.class == grade &&
      //             t.section == section &&
      //             t.teacherH == teacherName,
      //     );

      //     return teacher;
      // });
    },
    sectionChanged(value) {
      if (value.includes("Select All")) {
        value = this.sectionList.filter((g) => g != "Select All");
        this.section = value;
      }

      this.loadBranchList();
      this.loadGradesList();
    },
    getSectionQuery() {
      return this.section
        .map((s) => {
          const grade = s.split(" | ")[0].replace(/\(|\)/g, "");
          const section = s.split(" | ")[1].split(" - ")[0];
          const teacherName = s.split(" | ")[1].split(" - ")[1];

          // const teacher = this.teachers.find(
          //     (t) =>
          //         t.class == grade &&
          //         t.section == section &&
          //         t.teacherH == teacherName
          // );

          // return teacher.employeeID;
          return grade + "|" + section;
        })
        .join(",");
    },
    getGradeQueryFromSection() {
      if (!this.section.length) return "";

      return this.section
        .map((s) => {
          const grade = s.split(" | ")[0].replace(/\(|\)/g, "");
          const section = s.split(" | ")[1].split(" - ")[0];
          const teacherName = s.split(" | ")[1].split(" - ")[1];

          // const teacher = this.teachers.find(
          //     (t) =>
          //         t.class == grade &&
          //         t.section == section &&
          //         t.teacherH == teacherName
          // );

          // return teacher.employeeID;
          return grade;
        })
        .join(",");
    },
    gradesChanged(value) {
      if (value.includes("Select All")) {
        value = this.gradeList.filter((g) => g != "Select All");
        this.grade = value;
      }

      this.loadBranchList();
      this.loadTeacherList();
    },
    loadStudentsGrid() {
      if (!this.$refs.grid) return;

      const grades = [this.grade.join(","), this.getGradeQueryFromSection()];

      this.studentUrl =
        "students?branch=" +
        (this.branch.length ? this.branch.join(",") : "") +
        "&grade=" +
        grades.join(",") +
        "&section=" +
        this.getSectionQuery();

      if (this.$refs.grid) {
        this.$refs.grid.load(this.studentUrl);
      }

      if (this.$refs.parentGrid) {
        this.$refs.parentGrid.load(this.studentUrl);
      }
    },
    getBroadcastTime() {
      if (!this.isSchedule) return null;

      const time = moment(this.broadcastTime).format("HH:mm");

      const date = moment(this.broadcastDate).toDate();

      return moment(
        new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          time.split(":")[0],
          time.split(":")[1]
        )
      ).format("YYYY-MM-DD HH:mm:ss");
    },
    async onStudentsLoaded(students) {
      this.loadNumberCount();
    },
    async loadNumberCount() {
      const response = await this.$refs.grid.loadAll();

      this.students = response;
      this.studentCount = response.length;

      const group = groupBy(response, "familyID");

      this.parentCount = Object.keys(group).length;

      this.showParentsTable = true;

      const numbersCount = await this.$http.post(
        "api/broadcast/getNumbersCount?",
        Object.keys(group)
      );

      this.numbersCount = numbersCount;
    },
    getNumbersCount(type) {
      return this.numbersCount[type] || 0;
    },
    studentListMapper(students) {
      const group = groupBy(students, "familyID");

      return Object.keys(group).map((key) => {
        const family = group[key];

        return {
          familyID: key,
          name: family[0].name,
          hname: family[0].hname,
          address1: family[0].address1,
        };
      });
    },
    openChooseNumberDialog(mode) {
      this.selectNumberMode = mode;
      this.chooseNumbersDialog = true;
    },
    clearNumbers() {
      this.numbers = [];
      this.numbersToDisplay = [];
      this.manualNumbers = [
        {
          accountID: "",
          number: "",
        },
      ];
    },
    getPhoneTypes() {
      switch (this.phoneTypes) {
        case "Home Only":
          return ["PHON"];
        case "Father Cell":
          return ["CEL"];
        case "Mother Cell":
          return ["MCEL"];
        case "Home/Father Cell":
          return ["PHON", "CEL"];
        case "Home/Mother Cell":
          return ["PHON", "MCEL"];
        case "Home/Father/Mother Cell":
          return ["PHON", "CEL", "MCEL"];
      }
    },
    getPhoneTypeList() {
      return [
        "Home Only",
        // "Father Cell",
        // "Mother Cell",
        // "Home/Father Cell",
        // "Home/Mother Cell",
        // "Home/Father/Mother Cell",
      ];
    },
    openConfirmCloseDialog() {
      if (this.numbers.length) {
        this.confirmCloseDialog = true;
      } else {
        this.stepper = 1;
      }
    },
    goBackToSettings() {
      this.confirmCloseDialog = false;
      this.numbers = [];
      this.numbersToDisplay = [];

      this.stepper = 1;
    },
    continueToAudio() {
      if (!this.numbers.length) {
        this.$notify({
          text: "Please add numbers",
          group: "notification",
          type: "error",
        });

        return;
      }

      this.stepper = 3;
    },
    setPagianation() {
      if (this.getSkip() >= this.numbers.length) return;

      const number = (this.pagination.page - 1) * this.pagination.rowsPerPage;

      this.numbersToDisplay = this.numbers.slice(
        number,
        number + this.pagination.rowsPerPage
      );
    },
    getSkip() {
      const page = this.pagination.page - 1;

      let skip = page * this.pagination.rowsPerPage;

      if (skip >= this.numbers.length) {
        skip = this.numbers.length - this.pagination.rowsPerPage;
      }

      return skip;
    },
    notifyError(text) {
      this.$notify({
        text: text,
        group: "notification",
        type: "error",
      });
    },
    async addNumbers() {
      if (this.selectNumberMode == "studentList") {
        if (!this.$refs.branch.validate(true)) return;

        if (!this.phoneTypes.length) {
          return this.notifyError("Please Select a phone type");
        }

        if (!this.selectedParents.length) {
          return this.notifyError("Please select students");
        }

        this.addingNumbers = true;

        //const data = await this.$refs.grid.loadAll();

        const response = await this.$http.post("api/broadcast/loadNumbers", {
          accountIDs: this.selectedParents.map((d) => d.accountID),
          source: this.source,
        });

        const phoneTypes = this.getPhoneTypes();

        const group = groupBy(response.numbers, "accountID");

        const numberList = Object.keys(group)
          .map((key) => {
            const numbers = group[key].filter((n) => n.phoneNum);

            const filteredNumbers = numbers.filter((n) =>
              phoneTypes.includes(n.phoneType)
            );

            // if (
            //     numbers.some((n) =>
            //         this.phoneTypes.includes(n.phoneType)
            //     )
            // ) {
            //     return filteredNumbers;
            // }

            // if (this.phoneTypes.includes("PHON")) {
            //     return filteredNumbers;
            // }

            if (!this.phoneTypes.includes("PHON")) {
              return filteredNumbers.length
                ? filteredNumbers
                : numbers.filter((n) => n.phoneType == "PHON");
            }

            return filteredNumbers;
          })
          .flat();

        numberList.forEach((n) => {
          const number = n.phoneNum.replaceAll("-", "");

          if (this.numbers.some((sn) => sn.number == number)) return;

          this.numbers.push({
            accountID: n.accountID,
            name: n.name,
            nameH: n.nameH,
            number: number,
            phoneType: n.phoneType,
            selected: false,
          });
        });
      } else if (this.selectNumberMode == "manualEntry") {
        const numbers = this.manualNumbers.filter((n, index) => {
          return n.number && this.$refs.manualNumber[index].validate(true);
        });

        if (!numbers.length) {
          return this.notifyError(
            this.manualNumbers.filter((n) => n.number).length
              ? "No Valid Numbers Entered"
              : "No Numbers Entered"
          );
        }

        const response = await this.$http.post("api/broadcast/loadAccounts", {
          accountIDs: numbers.map((a) => a.accountID),
          source: this.source,
        });

        numbers.forEach((n) => {
          const number = n.number.replaceAll("-", "");

          if (this.numbers.some((sn) => sn.number == number)) return;

          const account = response.accounts.find(
            (a) => a.accountID == (n.accountID ? n.accountID.toUpperCase() : "")
          );

          this.numbers.push({
            accountID: n.accountID ? n.accountID.toUpperCase() : "",
            name: account ? account.name : "",
            nameH: account ? account.nameH : "",
            number: number,
            selected: false,
          });
        });

        this.manualNumbers = [
          {
            accountID: "",
            number: "",
          },
        ];
      } else if (this.selectNumberMode == "staffList") {
        this.addingNumbers = true;

        this.selectedStaff.forEach((teacher) => {
          if (!teacher.alertPhone || teacher.alertPhone.length < 10) return;

          if (this.numbers.some((sn) => sn.number == teacher.alertPhone))
            return;

          this.numbers.push({
            employeeID: teacher.employeeID,
            name: teacher.teacher,
            nameH: teacher.teacherH,
            number: teacher.alertPhone
              ? teacher.alertPhone.replaceAll("-", "")
              : teacher.alertPhone,
            selected: false,
          });
        });
      }

      this.addingNumbers = false;
      this.chooseNumbersDialog = false;
      this.numbersToDisplay = this.numbers.slice(0, 13);
      this.selectedParents = [];
      this.selectedStaff = [];
    },
    addNumber() {
      this.manualNumbers.push({
        accountID: "",
        number: "",
      });

      this.$forceUpdate();
    },
    removeNumber(index) {
      this.manualNumbers.splice(index, 1);

      this.$forceUpdate();
    },
    removeDisplayNumber(number) {
      const numberIndex = this.numbers.indexOf(number);

      this.numbers.splice(numberIndex, 1);

      this.setPagianation();

      this.$forceUpdate();
    },
    async loadAudioLibrary() {
      this.loadingAudio = true;

      const audioLibrary = await this.$http.get(
        "api/broadcast/getAudioLibrary"
      );

      this.allAudioLibrary = audioLibrary
        .map((audio) => {
          audio.selected = false;
          audio.editing = false;
          audio.name = audio.name ? audio.name : "Unnamed";

          return audio;
        })
        .filter((audio) => {
          if (
            this.$store.state.authentication.branch &&
            !this.$store.state.authentication.branch.includes("null")
          ) {
            const branches = this.$store.state.authentication.branch.split(",");
            const audioBranches = audio.branch ? audio.branch.split(",") : [];

            return (
              audio.branch &&
              (branches.some((b) => b == audio.branch) ||
                audioBranches.some((ab) => branches.some((br) => br == ab)))
            );
          }

          return true;
        });

      this.audioLibrary = this.allAudioLibrary;
      this.loadingAudio = false;
    },
    onAudioSearch(value) {
      this.audioLibrary = [];

      if (!value) {
        this.audioLibrary = this.allAudioLibrary;
      } else {
        this.audioLibrary = this.allAudioLibrary.filter((a) =>
          a.name
            ? a.name.toLowerCase().includes(value.trim().toLowerCase())
            : false
        );
      }
    },
    audioFromDateChanged(value) {
      this.audioLibrary = [];

      if (!value) {
        this.audioLibrary = this.allAudioLibrary;
      } else {
        const date = new Date(value + "T00:00:00");

        this.audioLibrary = this.allAudioLibrary.filter((a) => {
          const audioDate = new Date(a.date);
          return audioDate >= date;
        });
      }
    },
    editAudio(audio) {
      audio.editing = true;
      audio.originalName = audio.name;
    },
    cancelAudioName(audio) {
      audio.name = audio.originalName;
      audio.editing = false;
    },
    async saveAudioName(audio) {
      audio.editing = false;

      await this.$http.post(
        "api/broadcast/updateAudioName?id=" + audio.id + "&name=" + audio.name
      );

      this.loadAudioLibrary();
    },
    openDeleteAudioDialog(audio) {
      this.audioToDelete = audio;

      this.deleteAudioDialog = true;
    },
    getRoles() {
      return Array.isArray(this.$store.state.authentication.roles)
        ? this.$store.state.authentication.roles
        : this.$store.state.authentication.roles
        ? this.$store.state.authentication.roles.split(",")
        : [];
    },
    allowBroadcastToParents() {
      return !this.getRoles().includes("BroadcastStaffOnly");
    },
    isTransportationRole() {
      return this.getRoles().includes("Transportation");
    },
    async deleteAudio() {
      this.deleting = true;

      await this.$http.post(
        "api/broadcast/deleteAudio?id=" + this.audioToDelete.id
      );

      this.deleting = false;
      this.deleteAudioDialog = false;

      this.loadAudioLibrary();
    },
    selectAudio(audio) {
      this.audioLibrary
        .filter((a) => a.recordingURL != audio.recordingURL)
        .forEach((a) => (a.selected = false));

      audio.selected = true;

      this.selectedAudio = audio;
      this.audioFile = audio.recordingURL;
    },
    pickFile() {
      this.$refs.files.click();
    },
    async onFilePicked(e) {
      this.uploading = true;

      const files = e.target.files;

      if (!files) return;

      try {
        var formData = new FormData();

        this.files = files;

        formData.append("upload_file", this.files[0]);

        const response = await this.$http.post(
          "api/broadcast/uploadAudioFile?user=" +
            this.$store.state.authentication.user +
            "&branch=" +
            this.$store.state.authentication.branch,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.uploading = false;

        this.loadAudioLibrary();
      } catch (e) {
        this.uploading = false;
      }
    },
    continueToReview() {
      if (!this.audioFile && this.broadcastType == "VOICE") {
        this.$notify({
          text: "Please choose an audio file",
          group: "notification",
          type: "error",
        });

        return;
      }

      if (this.$refs.message && !this.$refs.message.validate(true)) return;

      if (!this.message && this.broadcastType == "TEXT") {
        this.$notify({
          text: "Message Required",
          group: "notification",
          type: "error",
        });

        return;
      }

      this.stepper = 4;
    },
    showEnterNotice() {
      const users = [
        "12561@utaw.org",
        "256@utaw.org",
        "258@utaw.org",
        "257@utaw.org",
        "jwercberger@utaw.org",
      ];

      return users.includes(this.$store.state.authentication.user);
    },
    onKeyDown(event) {
      //To Remove
      const users = [
        "12561@utaw.org",
        "256@utaw.org",
        "257@utaw.org",
        "258@utaw.org",
        "jwercberger@utaw.org",
      ];

      if (users.includes(this.$store.state.authentication.user)) {
        if (event.keyCode === 13 && !event.shiftKey) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    },
    getTotalCalls() {
      return this.numbers.length;
    },
    callRequest(isTest) {
      const url =
        this.broadcastType == "TEXT"
          ? "https://broadcast-3t6ck5zrrq-ue.a.run.app/broadcast/broadcastMessage"
          : "https://broadcast-3t6ck5zrrq-ue.a.run.app/broadcast/broadcastCall";

      return this.$http.post(url, {
        from: this.broadcastType == "TEXT" ? "18666609260" : this.fromNumber,
        broadcastID: this.broadcastID,
        user: this.$store.state.authentication.user,
        types: this.getPhoneTypes(),
        audioFile: this.broadcastType == "TEXT" ? null : this.audioFile,
        audioID: this.broadcastType == "TEXT" ? null : this.selectedAudio.id,
        text: this.broadcastType == "TEXT" ? this.message : null,
        broadcastName: this.callName,
        confirmListing: this.confirmListing,
        repeat: 2,
        isTest: isTest,
        testNumber: this.testNumber,
        requestID: 0,
        isMenahalBroadcast: true,
        numbers: this.numbers.map((number) => {
          return {
            accountID: number.accountID,
            number: number.number,
          };
        }),
        branch: this.branch.join(","),
        grade: this.grade.join(","),
        numberSelectionMode: this.selectNumberMode,
        accountsSource: this.source,
        broadcastTime: this.getBroadcastTime(),
      });
    },
    async send(isTest = false) {
      try {
        if (isTest) {
          this.broadcastID = await this.callRequest(isTest);
        } else {
          this.sending = true;

          this.callRequest(isTest);
        }

        if (!isTest) {
          this.sending = false;
          this.$router.push({
            name: "MenahalBroadcasts",
          });
        } else {
          this.$notify({
            text: "Test call sent",
            group: "notification",
            type: "success",
          });
        }
      } catch (e) {
        this.sending = false;
      }
    },
  },
};
</script>
<style>
.time-list .dx-texteditor.dx-state-focused.dx-editor-outlined {
  border-color: #30a635 !important;
}
.time-list .dx-texteditor.dx-state-hover {
  border-color: #30a635 !important;
}
.selected-tab {
  color: rgb(76, 175, 80) !important;
  border-bottom: 1px solid rgb(76, 175, 80) !important;
}
</style>
